module.exports = __webpack_public_path__ + "media/packs/assets/images/delete-e648873db28f00ad774bc96e8daae72b.png";